import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { whatsappLink } from "@/data/constants";
import { getStoredUtm } from "@/lib/utm";

import { API } from "@/lib/api";
const WHATSAPP_OPEN_DELAY_MS = 900;
const DEFAULT_MIN_QUANTITY = 50;

const buildWhatsappMessage = (payload) =>
  encodeURIComponent(
    `Olá! Acabei de solicitar um orçamento pelo site:\n\n` +
      `• Nome: ${payload.name}\n` +
      `• Empresa: ${payload.company || "-"}\n` +
      `• Produto: ${payload.product}\n` +
      `• Quantidade: ${payload.quantity}\n` +
      `• Mensagem: ${payload.message || "-"}`
  );

const extractError = (err) =>
  err?.response?.data?.detail || "Não foi possível enviar agora. Tente novamente em instantes.";

/**
 * Submits a quote payload to the backend and opens a prefilled WhatsApp tab.
 * Exposes [loading, submit] for the QuoteForm component.
 */
export default function useQuoteSubmit({ onSuccess } = {}) {
  const [loading, setLoading] = useState(false);

  const submit = async (form) => {
    if (loading) return;
    setLoading(true);
    try {
      const payload = {
        ...form,
        quantity: Number(form.quantity) || DEFAULT_MIN_QUANTITY,
        ...getStoredUtm(),
      };
      await axios.post(`${API}/quotes`, payload);
      toast.success("Orçamento enviado! Nossa equipe entrará em contato em breve.", {
        description: "Você será redirecionado ao WhatsApp para acelerar o atendimento.",
      });
      setTimeout(() => {
        window.open(whatsappLink(buildWhatsappMessage(payload)), "_blank", "noopener");
      }, WHATSAPP_OPEN_DELAY_MS);
      onSuccess?.();
    } catch (err) {
      toast.error("Falha ao enviar orçamento", { description: String(extractError(err)) });
    } finally {
      setLoading(false);
    }
  };

  return { loading, submit };
}
